import { ReactNode } from 'react'
import styled from 'styled-components'
import SearchInput from '../../../../../generic/ui/SearchInput/SearchInput'

interface Props {
  /** Group selector (or static label) — takes the leftmost flex slot in the top row. */
  groupSelector?: ReactNode
  /** Action chips (e.g. remark, basket). Rendered inline after the group selector. */
  actions?: ReactNode
  /** Filter chip (e.g. show-ordered / show-problems / close-filter). Rendered at end of top row. */
  filterButton?: ReactNode

  searchValue: string
  onSearchChange: (value: string) => void
  searchPlaceholder?: string
  className?: string
}

const OrdersToolbar: React.FC<Props> = ({
  groupSelector,
  actions,
  filterButton,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'חיפוש מוצרים',
  className,
}) => {
  return (
    <Bar className={className}>
      <SearchSlot>
        <SearchInput
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          showKbd
        />
      </SearchSlot>
      {groupSelector ? <GroupSlot>{groupSelector}</GroupSlot> : null}
      {(actions || filterButton) ? (
        <ChipsCluster>
          {actions}
          {filterButton}
        </ChipsCluster>
      ) : null}
    </Bar>
  )
}

export default OrdersToolbar

/* Desktop breakpoint: above this width all toolbar slots fit on one row.
 * Below it (mobile + tablet + narrow desktop) the search wraps to a second
 * line so the group selector + chip cluster stay together on row one. */
const DESKTOP_MIN = '1200px'

const Bar = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  direction: rtl;
`

const GroupSlot = styled.div`
  flex: 1 1 8rem;
  min-width: 0;
`

const ChipsCluster = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex: 0 0 auto;
  flex-wrap: nowrap;
`

const SearchSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1 auto;
  min-width: 0;

  @media (max-width: ${DESKTOP_MIN}) {
    flex-basis: 100%;
    order: 1;
  }
`
